module.exports = __webpack_public_path__ + "static/parade-2020-house56-c5a70f6fda8bd40862ae3d084ef4485e.jpg";